var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "mt-5 mb-0 pb-0", attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Parent Code",
                  items: _vm.parentCodes,
                  "item-value": "id",
                  "item-text": "account_code",
                  "return-object": "",
                  dense: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text mr-2" }, [
                          _vm._v(_vm._s(item.account_code))
                        ]),
                        _c("small", { staticClass: "blue-grey--text" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.parentCode,
                  callback: function($$v) {
                    _vm.parentCode = $$v
                  },
                  expression: "parentCode"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "mb-0 pb-0", attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Account Code",
                  items: _vm.accountCodes,
                  dense: "",
                  "item-value": "id",
                  "item-text": "account_code",
                  "error-messages":
                    _vm.voucherDetailStorePostErrors.account_code_id
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text mr-2" }, [
                          _vm._v(_vm._s(item.account_code))
                        ]),
                        _c("small", { staticClass: "blue-grey--text" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.accountCodeId,
                  callback: function($$v) {
                    _vm.accountCodeId = $$v
                  },
                  expression: "accountCodeId"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "mb-0 pb-0", attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Amount",
                  type: "number",
                  dense: "",
                  "error-messages": _vm.voucherDetailStorePostErrors.amount
                },
                model: {
                  value: _vm.amount,
                  callback: function($$v) {
                    _vm.amount = _vm._n($$v)
                  },
                  expression: "amount"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "mb-0 pb-0", attrs: { cols: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  label: "Reason",
                  dense: "",
                  outlined: "",
                  "no-resize": "",
                  "error-messages": _vm.voucherDetailStorePostErrors.reason
                },
                model: {
                  value: _vm.reason,
                  callback: function($$v) {
                    _vm.reason = $$v
                  },
                  expression: "reason"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "mb-0 pb-0", attrs: { cols: "12" } },
            [
              !_vm.editMode
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        dense: "",
                        small: "",
                        text: "",
                        loading: _vm.voucherDetailStorePosting
                      },
                      on: { click: _vm.store }
                    },
                    [_c("span", [_vm._v("Add")])]
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "yellow darken-3",
                            dense: "",
                            small: "",
                            text: "",
                            loading: _vm.voucherDetailStorePosting
                          },
                          on: { click: _vm.update }
                        },
                        [_c("span", [_vm._v("Update")])]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            dense: "",
                            small: "",
                            text: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.editMode = false
                            }
                          }
                        },
                        [_c("span", [_vm._v("Cancel")])]
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }